<template>
    <div class="data-container row">
        <b-table show-empty
            :empty-text="(loading) ? 'Loading...' : storeVoucherCodesEmptyText"
            :items="storeVoucherCodesIsSearching ? [] : storeVoucherCodes"
            :fields="fields"
            responsive>
            <template slot="is_used" slot-scope="row">
                <span :class="['status d-inline-block text-center text-uppercase border px-2 py-1 rounded', {
                    'used': row.value == 1
                }]">
                    {{ row.value ? "Used" : "Unused" }}
                </span>
            </template>
        </b-table>
        <Pagination :filters="filters" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Pagination from "@/views/dstore/store-vouchers/VoucherCodesPagination";
export default {
    name: "StoreVoucherCodes",
    props: ["filters"],
    components: {
        Pagination
    },
    computed: {
        ...mapState("estoreVouchers", [
            "loading",
            "storeVoucherCodes",
            "storeVoucherCodesEmptyText",
            "storeVoucherCodesIsSearching"
        ])
    },
    data() {
        return {
            fields: [
                { key: "code", label: "Voucher Code", sortable: true, thClass: "text-left", tdClass: "text-left" },
                { key: "is_used", label: "Status", sortable: true, thClass: "text-left" }
            ]
        }
    }
}
</script>
